import { useQuery } from "@tanstack/react-query";
import { Zone } from "../type/Zone";
import { fetcher } from "@/shared/core-configs";
import { API } from "@/config";

export const GET_ZONES_FETCH_KEY = "GET_ZONES_FETCH_KEY";

export const getZone = async () => {
  const response = await fetcher.get(`${API.GESLUB}/zones`);
  return response.data;
};

export const useGetZone = () => {
  const { data, error, isPending } = useQuery<Zone[]>({
    queryKey: [GET_ZONES_FETCH_KEY],
    queryFn: getZone,
  });
  return { data, error, isPending };
};
